import type { PromptReceiptPayload } from "@/lib/prompt-receipt-bus";
import { isContinuousVoiceActive } from "./continuous-voice-store";
import { adoptLiveTalkSpeechOwnerForReceipt } from "./live-talk-tts-control";
import { resetLiveTalkSpeechOwnershipForTests } from "./live-talk-speech-ownership";

const MAX_SEEN_RECEIPTS = 256;
const seenReceipts = new Set<string>();

export function handleLiveTalkPromptReceipt(
  receipt: PromptReceiptPayload,
): boolean {
  if (
    receipt.accepted !== true ||
    receipt.delivery_pending !== false ||
    receipt.prompt_source !== "continuous" ||
    !receipt.execution_id ||
    !receipt.client_request_id
  ) {
    return false;
  }
  const identity = receipt.delivery_identity || receipt.execution_id;
  if (seenReceipts.has(identity)) return false;
  seenReceipts.add(identity);
  while (seenReceipts.size > MAX_SEEN_RECEIPTS) {
    const oldest = seenReceipts.values().next().value;
    if (oldest === undefined) break;
    seenReceipts.delete(oldest);
  }
  if (!isContinuousVoiceActive()) return false;
  // A steered follow-up gets no reply of its own: the running turn it went
  // into answers it, so that turn is the one that speaks.
  const steeredInto = receipt.steered_into_execution_id;
  if (
    !adoptLiveTalkSpeechOwnerForReceipt(
      receipt.client_request_id,
      steeredInto || receipt.execution_id,
      Boolean(steeredInto),
    )
  ) {
    return false;
  }
  return true;
}

export function resetLiveTalkPromptReceiptsForTests(): void {
  seenReceipts.clear();
  resetLiveTalkSpeechOwnershipForTests();
}
